// extracted by mini-css-extract-plugin
module.exports = {"container":"container___p4mIq","info":"info___30OoM","paperTab":"paperTab___1kgwv"};